<div v-if="showEditor" class="mt-2 m-2 d-flex align-items-center flex-wrap gap-2">
  <span class="btn btn-sm btn-outline-secondary text-xxs px-3 py-1" @click="$emit('open-edit-category-modal')">Tag a category</span>
  <div class="d-flex flex-wrap gap-1">
    <span
      v-for="tag in allSelectedTags"
      :key="tag.id"
      class="btn-sm d-flex align-items-center bg-light border px-3 py-1"
    >
      {{ tag.name }}
    </span>
  </div>
</div>

<teleport v-if="showEditor" to="body">
  <div class="modal fade" id="category_modal_edit" tabindex="-1" aria-labelledby="category_modal_label" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content border-0 rounded-5 shadow-sm">
        <div class="modal-header">
          <h6 class="modal-title" id="category_modal_label">Select Tags for Category</h6>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <div class="modal-body">
          <div class="mb-4">
            <label class="form-label fw-bold mb-1">Primary Tag</label>

            <div v-for="(category, index) in categories" :key="'primary-edit-'+category.id" v-show="index < 2 || showAllPrimary" class="col-md-12">
              <label class="form-label fw-bold mb-1 text-xxs">{{ category.name }}</label>

              <multiselect
                :model-value="primaryTags.get(category.id)"
                @update:modelValue="tag => $emit('select-primary-tag', category.id, tag)"
                :options="category.tags"
                :multiple="false"
                placeholder="Select primary tag"
                track-by="id"
                label="name"
                class="text-xs fw-500 mb-3"
              >
                <template #option="{ option }">
                  <span class="fw-500 text-xxs">{{ option.name }}</span>
                </template>
                <template #selection="{ values }">
                  <span v-if="values" class="badge bg-success">{{ values.name }}</span>
                </template>
              </multiselect>
            </div>

            <div v-if="categories.length > 2" class="mt-2">
              <button type="button" class="btn btn-link btn-sm text-decoration-none" @click="showAllPrimary = !showAllPrimary">
                {{ showAllPrimary ? 'Show Less' : 'Show More' }}
              </button>
            </div>
          </div>

          <div class="mb-4">
            <label class="form-label fw-bold mb-1">Secondary Tags</label>

            <div v-for="(category, index) in categories" :key="'secondary-edit-'+category.id" v-show="index < 2 || showAllSecondary" class="col-md-12">
              <label class="form-label fw-bold mb-1 text-xxs">{{ category.name }}</label>

              <multiselect
                :model-value="selectedTags.get(category.id)"
                @update:modelValue="$emit('update-tag-selection', category.id, $event)"
                :options="category.tags"
                :multiple="true"
                :preserve-search="true"
                :close-on-select="false"
                :clear-on-select="false"
                placeholder="Select tags"
                class="text-xs fw-500 mb-3"
                track-by="id"
                label="name"
              >
                <template #option="{ option }">
                  <span class="fw-500 text-xxs">{{ option.name }}</span>
                </template>
                <template #selection="{ values }">
                  <span v-for="(tag, index) in values" :key="index" class="badge bg-primary me-1">
                    {{ tag.name }}
                  </span>
                </template>
              </multiselect>
            </div>

            <div v-if="categories.length > 2" class="mt-2">
              <button type="button" class="btn btn-link btn-sm text-decoration-none" @click="showAllSecondary = !showAllSecondary">
                {{ showAllSecondary ? 'Show Less' : 'Show More' }}
              </button>
            </div>
          </div>
        </div>

        <div class="text-end">
          <button
            type="button"
            class="btn btn-primary btn-sm text-xxs rounded-3 shadow-sm m-3"
            @click="$emit('submit-tags')"
            data-bs-toggle="modal"
            data-bs-target="#edit_report_modal"
            data-bs-dismiss="modal"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  </div>
</teleport>

<div v-if="showFilter" class="col-12 col-md-6 col-lg-12 mb-2 d-none d-md-block mt-2">
  <div class="home-category-filter-card bg-white border rounded shadow-sm overflow-hidden d-none d-xl-block" v-if="clientFeatures.show_categories">
    <div class="home-category-filter-header d-flex align-items-center justify-content-between gap-2 border-bottom">
      <div>
        <p class="text-dark fw-bold mb-0 text-xs">Categories & tags</p>
      </div>
      <div class="d-flex align-items-center gap-2">
        <CreateSubject @newSubject="$emit('new-subject', $event)" />
        <AllSubjects />
      </div>
    </div>

    <div class="home-category-filter-body scrollable-container p-2" v-if="categories.length && clientFeatures.show_tags">
      <div v-for="(category, categoryIndex) in categories" :key="categoryIndex" class="home-category-filter-group border rounded overflow-hidden mb-2">
        <div
          class="home-category-filter-toggle d-flex align-items-center justify-content-between gap-2 bg-light p-2 pointer"
          v-if="category.tags && category.tags.length"
          data-bs-toggle="collapse"
          :data-bs-target="`#collapse-category-${category.id}`"
          aria-expanded="true"
          :aria-controls="`collapse-category-${category.id}`"
        >
          <h6>
            {{ category.name || 'Unknown Category' }}
          </h6>
          <button type="button" class="btn btn-light border rounded d-inline-flex align-items-center justify-content-center p-0 home-category-filter-arrow" aria-label="Toggle category">
            <i class="bi bi-chevron-down"></i>
          </button>
        </div>

        <div v-else class="home-category-filter-toggle d-flex align-items-center justify-content-between gap-2 bg-light p-2">
          <h6>
            {{ category.name || 'Unknown Category' }}
          </h6>
        </div>

        <div v-if="category.tags && category.tags.length" :id="`collapse-category-${category.id}`" class="collapse home-category-filter-options p-2">
          <label
            v-for="tag in category.tags"
            :key="tag.id"
            class="home-category-filter-option d-flex align-items-center gap-2 rounded pointer mb-0"
            :class="{ 'is-selected': isTagSelected(tag.id) }"
            :for="`tag-${tag.id}`"
          >
            <input
              class="form-check-input checkbox-sm small mx-0 pointer"
              type="checkbox"
              :id="`tag-${tag.id}`"
              :checked="isTagSelected(tag.id)"
              @change="$emit('toggle-tag', tag.id)"
            />
            <span>{{ tag.name || 'Unknown Tag' }}</span>
          </label>
        </div>
      </div>
    </div>

    <div class="home-category-filter-body scrollable-container p-2" v-else-if="subjects.length && clientFeatures.show_subjects">
      <div v-for="subject in subjects" :key="subject.id" class="home-category-filter-group border rounded overflow-hidden mb-2">
        <div
          class="home-category-filter-toggle d-flex align-items-center justify-content-between gap-2 bg-light p-2 pointer"
          data-bs-toggle="collapse"
          :data-bs-target="`#collapse-subject-${subject.id}`"
          aria-expanded="true"
          :aria-controls="`collapse-subject-${subject.id}`"
        >
          <h6>{{ subject.name }}</h6>
          <button type="button" class="btn btn-light border rounded d-inline-flex align-items-center justify-content-center p-0 home-category-filter-arrow" aria-label="Toggle subject">
            <i class="bi bi-chevron-down"></i>
          </button>
        </div>

        <div :id="`collapse-subject-${subject.id}`" class="collapse home-category-filter-options p-2">
          <div
            v-for="([categoryId, tags]) in Array.from(groupedTagsById(subject.subject_tags))"
            :key="categoryId"
            class="home-category-filter-subgroup border rounded overflow-hidden mb-2"
          >
            <div
              class="home-category-filter-subtoggle d-flex align-items-center justify-content-between gap-2 bg-light p-2 pointer"
              data-bs-toggle="collapse"
              :data-bs-target="`#collapse-category-${subject.id}-${categoryId}`"
              aria-expanded="true"
              :aria-controls="`collapse-category-${subject.id}-${categoryId}`"
            >
              <label class="home-category-filter-option home-category-filter-category-option d-flex align-items-center gap-2 rounded pointer mb-0">
                <input
                  class="form-check-input checkbox-sm small mx-0 pointer"
                  type="checkbox"
                  :id="`category-${categoryId}-${subject.id}`"
                  :checked="isCategorySelected(categoryId)"
                  @click.stop
                  @change="$emit('toggle-category', subject.id, categoryId)"
                />
                <span @click.stop>
                  {{ tags[0]?.tag?.tag_category?.name || 'Unknown Category' }}
                </span>
              </label>

              <button type="button" class="btn btn-light border rounded d-inline-flex align-items-center justify-content-center p-0 home-category-filter-arrow" aria-label="Toggle category">
                <i class="bi bi-chevron-down"></i>
              </button>
            </div>

            <div :id="`collapse-category-${subject.id}-${categoryId}`" class="collapse home-category-filter-options p-2">
              <label
                v-for="tag in tags"
                :key="tag.tag?.id"
                class="home-category-filter-option d-flex align-items-center gap-2 rounded pointer mb-0"
                :class="{ 'is-selected': isTagSelected(tag.tag?.id) }"
                :for="`tag-${tag.tag?.id}`"
              >
                <input
                  class="form-check-input checkbox-sm small mx-0 pointer"
                  type="checkbox"
                  :id="`tag-${tag.tag?.id}`"
                  :checked="isTagSelected(tag.tag?.id)"
                  @change="$emit('toggle-tag', tag.tag?.id)"
                />
                <span>{{ tag.tag?.name || 'Unknown Tag' }}</span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-else>
      <p class="home-category-filter-empty">No topics found.</p>
    </div>
  </div>
</div>
